import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarginTopBottomIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M13.5 5.83203H6.5C5.09987 5.83203 4.3998 5.83203 3.86502 5.98341C3.39462 6.11657 3.01217 6.32904 2.77248 6.59038C2.5 6.88748 2.5 7.2764 2.5 8.05425V11.9431C2.5 12.721 2.5 13.1099 2.77248 13.407C3.01217 13.6684 3.39462 13.8808 3.86502 14.014C4.3998 14.1654 5.09987 14.1654 6.5 14.1654H10H13.5C14.9001 14.1654 15.6002 14.1654 16.135 14.014C16.6054 13.8808 16.9878 13.6684 17.2275 13.407C17.5 13.1099 17.5 12.721 17.5 11.9431V8.05425C17.5 7.2764 17.5 6.88748 17.2275 6.59038C16.9878 6.32904 16.6054 6.11657 16.135 5.98341C15.6002 5.83203 14.9001 5.83203 13.5 5.83203Z"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5827 17.5H9.99935H5.41602"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5827 2.5H9.99935H5.41602"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
